<template lang="html">
    <div class="newOrder">
    <breadcrumb :nameSection = 'nameSection' :listRoutes = 'listRoutes'></breadcrumb>
 <div class="form-content">
      <div class="form-content-title">

        <div class="form-content-title-block form-title">

          <div class="form-title-block form-title-principal">

            <span>Tabla de Rebate</span>

          </div>

          <div class="form-title-block" v-if="$store.state.user.attributes.permissions_keys.includes(8)">

            <button  class="btn btn-primary" @click="gotoPage(1)"><i class="fas fa-plus"></i>Nuevo Rebate</button>

          </div>

        </div>

        <div class="form-content-title-block filter-container">

          <div class="filter-block filter-block-various">

              <label>Buscar:</label>

                <input
                  id="search-bar"
                  type="search"
                  class="form-control"
                  v-model="tableData.filterValue"
                  placeholder="Buscar..."
                  @keyup="getrebateOrders()"
                >
                  
          </div>
          
        </div>

      </div>



      <div class="table-ship">
        
        <data-table
          :columns="columns"
          :sortKey="sortKey"
          :sortOrders="sortOrders"
          @sort="sortBy"
        >
          <tbody v-if="rebateOrders!=null && rebateOrders.length > 0" >

              <router-link :to="{ name: 'EditRebate',params: { id: rebateOrder.id, orderData: rebateOrder }}" v-for="(rebateOrder) in rebateOrders" :key="rebateOrder.id">
              <tr>
                <td>
                    <div class="" style="text-align: center">
                        <span >{{rebateOrder.product_title}}</span>
                    </div>
                </td>
                <td>
                  <span class="">{{rebateOrder.amount}}</span>
                </td>
                <td >
                  <div class="">
                      <span>{{rebateOrder.publication_code}}</span>
                  </div>
                </td>
                <td>
                  <div class="">
                    <span>{{rebateOrder.from}}</span>
                  </div>
                </td>
                <td >
                  <div class="">
                  <span class="">{{rebateOrder.to}}</span>
                  </div>
                </td>
                <td >
                  <div class="">
                  <span class="">{{rebateOrder.product_price}}</span>
                   </div>
                </td>
              </tr>
            </router-link>
          </tbody>
          <tbody  v-else>
            <div class="no-results">
              <h1>No se encontraron resultados</h1>
            </div>
          </tbody>

        </data-table>
      
      </div>

    </div>

  </div>

</template>

<script>
import breadcrumb from '@/components/prefab/structures/breadcrumb.vue'
import DataTable from './DataTable.vue'
import Pagination from './Pagination.vue'
import axios from 'axios'
export default {
  components: { DataTable, Pagination, breadcrumb },
  created() {
    if (!this.$store.state.user.attributes.permissions_keys.includes(6)) {
      this.grabr.id = '2'
    }
    if (this.rebateOrders == null) {
      this.is_loading = true
    }
    this.getrebateOrders()
  },
  data() {
    // eslint-disable-next-line no-unused-vars
    
    // eslint-disable-next-line no-unused-vars
    
    // eslint-disable-next-line no-unused-vars
    
    let sortOrders = {}
    let columns = [
      { label: 'Title', name: 'title', visible: true },
      { label: 'Amount', name: 'amount', visible: true },
      { label: 'Publication Code', name: 'publication_code', visible: true },
      { label: 'From', name: 'from', visible: true },
      { label: 'To', name: 'to', visible: true },
      { label: 'Price', name: 'price', visible: true },
    ]
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })
    return {
      rebateOrders: null,
      columns,
      sortKey: 'id',
      sortOrders: sortOrders,
      filterKey: '',
      expanded: false,
      tableData: {
        draw: 0,
        length: 10,
        status: '',
        orderBy: 'id',
        dir: 'desc',
        filterBy: 'all',
        page: 1,
        filterValue: null, // no hay ningun valor por el cual filtrar
        order_type: 5 // órdenes de Grabr y no Grabr
      },
      pagination: {
        lastPage: '',
        currentPage: '',
        total: '',
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      },
      grabr: {
        id: '1'
      },
      is_loading: true,
      nameSection: 'Tabla de Rebate',
      listRoutes: [{ nameRoute: 'TableRebate', titleRoute: 'Tabla de Rebate' }]
    }
  },
  methods: {
      gotoPage(val){
        if(val==1){
        this.$router.push({ name: 'Utils'});
      }
    },

    getrebateOrders(url = '', fromPagination = false) {
      // 1: Ver todas las órdenes de compra, 2: Ver todas las órdenes de compra por operador, 3: Ver todas las órdenes de compra por cliente
      console.log('Cargando todas las PurchasOrders')
      this.is_loading = true
      this.tableData.draw++
      let permissions = this.$store.state.user.attributes.permissions_keys
      if (!fromPagination) {
        if (permissions.includes(1)) {
          url = url = process.env.API_URL + '/api/rebate/list'
        } else {
          alert('El usuario no tiene permisos para ver órdenes de compra')
          return
        }
      }
      console.log('URL: ' + url)
      console.log('Viene de una paginación? : ' + fromPagination)
      console.log('Table data : ')

      console.log(this.tableData)
      // eslint-disable-next-line no-unreachable
      axios
        .get(url,{params:
          {filterValue:this.tableData.filterValue}
          })
        .then(response => {
          let data = response.data
          console.log("Ver la data ")
          console.log(data)
          console.log(data.body.data)
          console.log("final")
          this.rebateOrders = data.body.data
        })
        .catch(errors => {
          console.log(errors)
          console.log(errors.response)
          console.log('error')
          // alert('No se obtuvieron resultados')
          this.rebateOrders = null
          // this.is_loading = false
          return
        })
    },
    
    cleanInput() {
      this.tableData.filterValue = ''
      if (this.tableData.filterBy == 'all') {
        this.getrebateOrders()
      }
    },

    sortBy(key) {
      console.log('entro al sort', key)
      this.sortKey = key
      this.sortOrders[key] = this.sortOrders[key] * -1
      this.tableData.orderBy = this.sortKey
      /* this.tableData.orderBy = this.getIndex(this.columns, 'name', key) */
      console.log(
        'tableData.orderBy',
        this.tableData.orderBy,
        'tableData.dir',
        this.tableData.dir,
        this.sortOrders[key]
      )
      this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc'
      console.log(
        'tableData.orderBy',
        this.tableData.orderBy,
        'tableData.dir',
        this.tableData.dir
      )
      this.getrebateOrders()
      console.log('paso la peticion api')
    }

  
  },
  computed: {
    filterColumns() {
      let activeFilterColumns = [
        'title',
        'publication_code',
      ]
      
      return this.columns.filter(i => activeFilterColumns.indexOf(i.name) > -1)
    },

  }
}
</script>
<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// TableRebate.vue?3ca8e59c